module.exports = __webpack_public_path__ + "img/3f_comunity.e8b14b58.svg";